import { Fragment, type ReactElement } from "react";
import { Navigate, Route, useLocation } from "react-router-dom";
import { routes } from "routing";

/**
 * Old `/guestdup/*` paths, each mapped to its canonical `/guest-duplicate/*`
 * registry path. Kept for any already-shared links; in-app navigation should use
 * the registry paths directly rather than round-tripping through these.
 */
const LEGACY_GUEST_DUPLICATE_REDIRECTS: ReadonlyArray<readonly [from: string, to: string]> = [
  ["/guestdup/teamselect", routes.guestDuplicate.team.path],
  ["/guestdup/itineraryselect", routes.guestDuplicate.itinerary.path],
  ["/guestdup/datetimerangeselect", routes.guestDuplicate.dates.path],
];

function LegacyRedirect({ to }: { to: string }) {
  const { search, hash } = useLocation();
  return <Navigate to={`${to}${search}${hash}`} replace />;
}

export function legacyGuestDuplicateRedirects(): ReactElement {
  return (
    <Fragment>
      {LEGACY_GUEST_DUPLICATE_REDIRECTS.map(([from, to]) => (
        <Route key={from} path={from} element={<LegacyRedirect to={to} />} />
      ))}
    </Fragment>
  );
}
